module.exports = __webpack_public_path__ + "img/16.93f7f8d6.png";